<template>
  <el-popover
    placement="right"
    width="400"
    v-model="showBatchContract"
    style="margin-left: 5px"
    trigger="manual">
    <el-form ref="formRef" :model="form" label-width="100px" label-position="right" class="custom-form">
      <el-form-item label="合同状态" prop="zt">
        <el-radio-group v-model="form.zt">
          <el-radio :label="0">未审</el-radio>
          <el-radio :label="1">已审</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="dialog-footer" style="float: right">
        <el-button @click="handleClose" size="mini">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" size="mini">确 定</el-button>
      </div>
    </el-form>
    <el-button slot="reference" size="small" type="warning" @click="handleClick">批量审核合同</el-button>
  </el-popover>
</template>
<script>
import {defineComponent, reactive, ref} from "@vue/composition-api";
import useRootSetting from '@/hooks/useRootSetting'
import {Message} from "element-ui";
export default defineComponent({
  props: {
    showBatchContract: {
      type: Boolean,
      default: false
    },
    selectedIds: {
      type: [Array,Number],
      default: 0
    }
  },
  setup(props, {emit}) {
    const {getIsMobile} = useRootSetting()
    const formRef = ref(null)
    const form = reactive({
      zt: '',
    })
    const visible = ref(false)

    const handleSubmit = () => {
      formRef.value.validate(valid => {
        if (valid) {
          emit('submit', form,'batch')
        }
      })
    }
    const handleClose = () =>  emit('update:showBatchContract', false)

    const handleClick = () => {
      if(props.selectedIds == 0) {
        Message.warning('批量操作至少选择一条数据！')
      }else{
        emit('update:showBatchContract', true)
      }

    }

    return {
      visible,
      formRef,
      form,
      handleClick,
      handleSubmit,
      handleClose
    }
  }
})
</script>
